import {
  IssueId,
  SelfServeNode,
  SelfServeNodeLevel,
  SelfServeNodeLevels,
} from "../types";
import { StorageNodeValue } from "../utils/localStorage";

import { useTree } from "./useTree";

export type LevelToNode = {
  [key in SelfServeNodeLevel]: SelfServeNode;
};

export const useNodesFromLocalStorage = (
  levelToNodeId: StorageNodeValue | undefined
): LevelToNode => {
  const { tree } = useTree();
  if (!levelToNodeId) {
    return {} as LevelToNode;
  }

  const levelToNode = {} as LevelToNode;
  for (const level of SelfServeNodeLevels) {
    const nodeId = levelToNodeId[level] as IssueId;
    levelToNode[level] = tree[nodeId] as SelfServeNode;
  }
  return levelToNode;
};
